export class ARLedgerTableColumn {
  headerName: string;
  dataColumnName: string;
  isGroupColumn: boolean = false;
  showColumn: boolean = true;
  matColumnDef: string;
  colspan: number;
  childColumns: ARLedgerTableColumn[] = [];
}
